export const lighterBlueColor = "VEd";
export const lighterGreenColor = "WEd";
export const lighterYellowColor = "XEd";
export const lighterOrangeColor = "YEd";
export const lighterRedColor = "ZEd";
export const lighterPurpleColor = "_Ed";
export default {lighterBlueColor,lighterGreenColor,lighterYellowColor,lighterOrangeColor,lighterRedColor,lighterPurpleColor};